export const columns = [
	{
		title: "Operation",
		dataIndex: "operation",
		key: "operation",
	},
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
	},
	{
		title: "Amount, €",
		dataIndex: "amount",
		key: "amount",
	},
	{
		title: "Comment",
		dataIndex: "comment",
		key: "comment",
	},
];
